export const TolErrorsMutations = {
  SetErrorObject: 'TolErrorsMutations.SetErrorObject',
  SetMessage: 'TolErrorsMutations.SetMessage',
  SetItems: 'TolErrorsMutations.SetItems',
  AddItem: 'TolErrorsMutations.AddItem',
  RemoveItemByIndex: 'TolErrorsMutations.RemoveItemByIndex',
  SetKeepOnce: 'TolErrorsMutations.SetKeepOnce',
  ResetErrorsState: 'TolErrorsMutations.ResetErrorsState',
  SetServiceUnavailable: 'TolErrorsMutations.SetServiceUnavailable'
};

export const TolErrorsActions = {
  ClearAll: 'TolErrorsActions.ClearAll',
  SetError: 'TolErrorsActions.SetError',
  AddItem: 'TolErrorsActions.AddItem',
  RemoveItemByIndex: 'TolErrorsActions.RemoveItemByIndex',
  SetKeepOnce: 'TolErrorsActions.KeepOnce',
  SetServiceUnavailable: 'TolErrorsActions.SetServiceUnavailable'
};

export const TolErrorsGetters = {
  HasErrors: 'TolErrorsGetters.HasErrors',
  ErrorObject: 'TolErrorsGetters.ErrorObject',
  Message: 'TolErrorsGetters.Message',
  Items: 'TolErrorsGetters.Items',
  Item: 'TolErrorsGetters.Item',
  KeepOnce: 'TolErrorsGetters.KeepOnce',
  ServiceUnavailable: 'TolErrorsGetters.ServiceUnavailable'
};
